export default __webpack_public_path__ + "static/media/net-icon.179014aa.svg";